import axios from 'axios'
import router from '../router'
import App from '../App'

function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    var context = "";
    if (r != null)
        context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

function fixSiteIndexURL() {
    if (window.history.replaceState)
    window.history.replaceState(null, null, "index.html");
}

async function fetchAPI(params, token){
    let method = params.method || 'get'
    let url = params.url
    let headers = {'Accept': "application/json"}
    if(!url){
        console.error('fetchAPI expected request url but get undefined')
        return
    }

    let _opt = {
        method,
        url,
        headers,
        validateStatus: function (status) {
            return status < 1001
        }
    }

    if(params.body){
        _opt.data = params.body
    }
    if(_opt.method === 'post') {
        _opt.headers = {
            'Accept': "application/json",
            'X-CSRF-TOKEN': token
        }
    }
    let res = await axios(_opt)

    return res.data
}

function joinParams(params){
    let arr = []

    for(let i in params){
        params[i] && arr.push(`${i}=${encodeURIComponent(params[i])}`)
    }

    return arr.join('&')
}

function formatComma(data) {
  data = data.split(",").join('')

  if(data){
    return data.replace(/\D/g,'').replace(/^0+/g, '').replace(/(\d)(?=(?:\d{3})+$)/g,'$1,')
  }else{
    return ''
  }
}

export {
    joinParams,
    getQueryString,
    fixSiteIndexURL,
    fetchAPI,
    formatComma
}


// WEBPACK FOOTER //
// ./src/alias/utils.js